import { getLanguageIETF } from '@constants/locales';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFormattedDate = (
    options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    },
) => {
    const { i18n } = useTranslation();
    const IETF = getLanguageIETF(i18n.language);

    const dateFormatter = useMemo(() => {
        return new Intl.DateTimeFormat(IETF, options);
    }, [IETF, options]);

    const formatDate = (date: number | string | Date | undefined) => {
        if (!date) return;
        const parsedDate = date instanceof Date ? date : new Date(date);
        if (isNaN(parsedDate.getTime()))
            return typeof date === 'string' ? date : undefined;

        return dateFormatter.format(parsedDate);
    };

    return { formatDate };
};
